<div
    class="ml-2 rounded-lg transition max-w-60 p-2 flex flex-row gap-2 hover:text-custom-blue hover:bg-custom-light-blue"
    [class.cursor-not-allowed]="disabled()"
    [class.cursor-pointer]="!disabled()"
    [matTooltip]="matTooltip()"
    (click)="!disabled() && emitAction()">
    <fa-icon
        class="w-4 text-center"
        size="sm"
        [class.text-custom-blue]="!disabled()"
        [class.text-custom-dark-grey]="disabled()"
        [icon]="icon()" />

    <span
        class="!no-underline"
        [class.text-custom-dark-grey]="disabled()">
        {{ label() }}
    </span>
</div>
